// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Copyright 2014 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

 :root {
    --react-pdf-text-layer: 1;
    --highlight-bg-color: rgba(180, 0, 170, 1);
    --highlight-selected-bg-color: rgba(0, 100, 0, 1);
  }

  @media screen and (forced-colors: active) {
    :root {
      --highlight-bg-color: Highlight;
      --highlight-selected-bg-color: ButtonText;
    }
  }

  [data-main-rotation='90'] {
    transform: rotate(90deg) translateY(-100%);
  }
  [data-main-rotation='180'] {
    transform: rotate(180deg) translate(-100%, -100%);
  }
  [data-main-rotation='270'] {
    transform: rotate(270deg) translateX(-100%);
  }

  .textLayer {
    position: absolute;
    text-align: initial;
    inset: 0;
    overflow: hidden;
    line-height: 1;
    text-size-adjust: none;
    forced-color-adjust: none;
    transform-origin: 0 0;
    z-index: 2;
  }

  .textLayer :is(span, br) {
    color: transparent;
    position: absolute;
    white-space: pre;
    cursor: text;
    margin: 0;
    transform-origin: 0 0;
  }

  /* Only necessary in Google Chrome, see issue 14205, and most unfortunately
   * the problem doesn't show up in "text" reference tests. */
  .textLayer span.markedContent {
    top: 0;
    height: 0;
  }

  .textLayer .highlight {
    margin: -1px;
    padding: 1px;
    background-color: var(--highlight-bg-color);
    border-radius: 4px;
  }

  .textLayer .highlight.appended {
    position: initial;
  }

  .textLayer .highlight.begin {
    border-radius: 4px 0 0 4px;
  }

  .textLayer .highlight.end {
    border-radius: 0 4px 4px 0;
  }

  .textLayer .highlight.middle {
    border-radius: 0;
  }

  .textLayer .highlight.selected {
    background-color: var(--highlight-selected-bg-color);
  }

  /* Avoids https://github.com/mozilla/pdf.js/issues/13840 in Chrome */
  .textLayer br::selection {
    background: transparent;
  }

  .textLayer .endOfContent {
    display: block;
    position: absolute;
    inset: 100% 0 0;
    z-index: -1;
    cursor: default;
    -webkit-user-select: none;
            user-select: none;
  }

  .textLayer .endOfContent.active {
    top: 0;
  }`, "",{"version":3,"sources":["webpack://./src/components/PDFPreview/TextLayer.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;EAaE;;CAED;IACG,yBAAyB;IACzB,0CAA0C;IAC1C,iDAAiD;EACnD;;EAEA;IACE;MACE,+BAA+B;MAC/B,yCAAyC;IAC3C;EACF;;EAEA;IACE,0CAA0C;EAC5C;EACA;IACE,iDAAiD;EACnD;EACA;IACE,2CAA2C;EAC7C;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,cAAc;IACd,sBAAsB;IACtB,yBAAyB;IACzB,qBAAqB;IACrB,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,SAAS;IACT,qBAAqB;EACvB;;EAEA;6DAC2D;EAC3D;IACE,MAAM;IACN,SAAS;EACX;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,2CAA2C;IAC3C,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,oDAAoD;EACtD;;EAEA,oEAAoE;EACpE;IACE,uBAAuB;EACzB;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;EACnB;;EAEA;IACE,MAAM;EACR","sourcesContent":["/* Copyright 2014 Mozilla Foundation\n *\n * Licensed under the Apache License, Version 2.0 (the \"License\");\n * you may not use this file except in compliance with the License.\n * You may obtain a copy of the License at\n *\n *     http://www.apache.org/licenses/LICENSE-2.0\n *\n * Unless required by applicable law or agreed to in writing, software\n * distributed under the License is distributed on an \"AS IS\" BASIS,\n * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.\n * See the License for the specific language governing permissions and\n * limitations under the License.\n */\n\n :root {\n    --react-pdf-text-layer: 1;\n    --highlight-bg-color: rgba(180, 0, 170, 1);\n    --highlight-selected-bg-color: rgba(0, 100, 0, 1);\n  }\n\n  @media screen and (forced-colors: active) {\n    :root {\n      --highlight-bg-color: Highlight;\n      --highlight-selected-bg-color: ButtonText;\n    }\n  }\n\n  [data-main-rotation='90'] {\n    transform: rotate(90deg) translateY(-100%);\n  }\n  [data-main-rotation='180'] {\n    transform: rotate(180deg) translate(-100%, -100%);\n  }\n  [data-main-rotation='270'] {\n    transform: rotate(270deg) translateX(-100%);\n  }\n\n  .textLayer {\n    position: absolute;\n    text-align: initial;\n    inset: 0;\n    overflow: hidden;\n    line-height: 1;\n    text-size-adjust: none;\n    forced-color-adjust: none;\n    transform-origin: 0 0;\n    z-index: 2;\n  }\n\n  .textLayer :is(span, br) {\n    color: transparent;\n    position: absolute;\n    white-space: pre;\n    cursor: text;\n    margin: 0;\n    transform-origin: 0 0;\n  }\n\n  /* Only necessary in Google Chrome, see issue 14205, and most unfortunately\n   * the problem doesn't show up in \"text\" reference tests. */\n  .textLayer span.markedContent {\n    top: 0;\n    height: 0;\n  }\n\n  .textLayer .highlight {\n    margin: -1px;\n    padding: 1px;\n    background-color: var(--highlight-bg-color);\n    border-radius: 4px;\n  }\n\n  .textLayer .highlight.appended {\n    position: initial;\n  }\n\n  .textLayer .highlight.begin {\n    border-radius: 4px 0 0 4px;\n  }\n\n  .textLayer .highlight.end {\n    border-radius: 0 4px 4px 0;\n  }\n\n  .textLayer .highlight.middle {\n    border-radius: 0;\n  }\n\n  .textLayer .highlight.selected {\n    background-color: var(--highlight-selected-bg-color);\n  }\n\n  /* Avoids https://github.com/mozilla/pdf.js/issues/13840 in Chrome */\n  .textLayer br::selection {\n    background: transparent;\n  }\n\n  .textLayer .endOfContent {\n    display: block;\n    position: absolute;\n    inset: 100% 0 0;\n    z-index: -1;\n    cursor: default;\n    user-select: none;\n  }\n\n  .textLayer .endOfContent.active {\n    top: 0;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
